module.exports = __webpack_public_path__ + "img/docDni.a29ca680.svg";